import React from "react"

const IconLogo = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 890 890"
  >
    <path
      className="cls-1"
      d="M942,539.5H557v385C769.63,924.5,942,752.13,942,539.5Z"
      transform="translate(-78 -95)"
    />
    <path
      className="cls-2"
      d="M523,540H908c0-212.63-172.37-385-385-385S138,327.37,138,540,310.37,925,523,925"
      transform="translate(-78 -95)"
    />
  </svg>
)

export default IconLogo
